import React from 'react';
import { Card } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Coverage } from '@/hooks/useTestRunner';

interface TestCoverageChartProps {
  coverage: Coverage;
}

const TestCoverageChart = ({ coverage }: TestCoverageChartProps) => {
  const metrics = [
    { label: 'Linhas', value: coverage.lines, color: 'bg-blue-500' },
    { label: 'Statements', value: coverage.statements, color: 'bg-green-500' },
    { label: 'Funções', value: coverage.functions, color: 'bg-purple-500' },
    { label: 'Branches', value: coverage.branches, color: 'bg-orange-500' },
  ];

  const getColorClass = (value: number) => {
    if (value >= 80) return 'text-green-500';
    if (value >= 60) return 'text-yellow-500';
    return 'text-red-500';
  };

  return (
    <Card className="p-6 bg-card border-border">
      <h2 className="text-xl font-semibold mb-6 text-foreground">Cobertura de Código</h2>
      <div className="space-y-6">
        {metrics.map((metric) => (
          <div key={metric.label}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-muted-foreground">
                {metric.label}
              </span>
              <span className={`text-lg font-bold ${getColorClass(metric.value)}`}>
                {metric.value.toFixed(1)}%
              </span>
            </div>
            <Progress value={metric.value} className="h-3" />
          </div>
        ))}
      </div>
      
      {/* Average Coverage */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-base font-semibold text-foreground">
            Cobertura Média
          </span>
          <span className={`text-2xl font-bold ${getColorClass(
            (coverage.lines + coverage.statements + coverage.functions + coverage.branches) / 4
          )}`}>
            {((coverage.lines + coverage.statements + coverage.functions + coverage.branches) / 4).toFixed(1)}%
          </span>
        </div>
      </div>
    </Card>
  );
};

export default TestCoverageChart;
